import {Config} from "./config-viewmodel";

export interface MyStudyChoiceCreatedModelState {
    config: Config
}

export class WidgetState implements MyStudyChoiceCreatedModelState {
    config: Config = {
        labels: {
            primaryTitle: '',
            secondaryTitle: '',
            description: ''
        }
    }
}